import { Box, Button, Stack, Typography } from "@mui/material";
import React, { MouseEventHandler } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

type PropsType = {
  title: string;
  handleAddClick: MouseEventHandler<HTMLButtonElement>;
  disabledTrashState: boolean;
  handleBulkDelete: MouseEventHandler<HTMLButtonElement>;
};

export default function CustomGridHeader(props: PropsType) {
  const { handleBulkDelete, title, handleAddClick, disabledTrashState } = props;
  return (
    <Stack
      mb={2}
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      justifyContent="space-between"
    >
      <Typography
        variant="h6"
        fontSize={"1.67rem"}
        gutterBottom
        m={1}
        textTransform="capitalize"
        color="text.primary"
      >
        {title}
      </Typography>
      <Box>
        <Button
          variant="contained"
          onClick={handleAddClick}
          startIcon={<AddIcon />}
          sx={{ mr: 1 }}
        >
          {title}
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={handleBulkDelete}
          // onClick={() => handleTrash(customOptions)}
          disabled={disabledTrashState}
          startIcon={<DeleteIcon />}
        >
          Trash
        </Button>
      </Box>
    </Stack>
  );
}
